import { css } from "@emotion/react"

import { above } from "@mkt/cp/src/styles/Breakpoints"
import { colorsCP, fontsCP } from "@mkt/cp/src/styles/Tokens"
import { animeShow } from "@mkt/ui/styles/Keyframes"
import { getDuration } from "@mkt/cp/src/styles/Functions"

export const slider = () => {
  return css`
    width: 100%;

    ${above["m"]} {
      display: block;
    }
  `
}

export const content = css`
  display: flex;
  flex-direction: column;
  gap: 16px;

  ${above["m"]} {
    gap: 48px;
  }
`

export const header = (sliderCSSVars) => {
  const show = css`
    display: flex;
  `

  const hide = css`
    display: none;
  `

  return css`
    display: ${sliderCSSVars.showHeader};
    align-items: center;
    justify-content: space-between;

    ${above["m"]} {
      display: ${sliderCSSVars.showHeaderTablet};
    }

    ${above["l"]} {
      display: ${sliderCSSVars.showHeaderDesk};
    }
  `
}

export const title = css`
  font-family: ${fontsCP['font-secondary']['font-family']};
  font-weight: 700;
  font-size: 24px;
  line-height: 1.4;
  color: ${colorsCP['neutral-70']};
  text-align: left;
  opacity: 0;
  animation: ${animeShow} ${getDuration(1)} 0.2s ease forwards;

  ${above["m"]} {
    font-size: 28px;
  }
`

export const subtitle = css`
  font-family: ${fontsCP['font-primary']['font-family']};
  font-weight: 400;
  font-size: 20px;
  line-height: 1.5;
  color: ${colorsCP["neutral-50"]};
  padding-top: 24px;
  opacity: 0;
  animation: ${animeShow} ${getDuration(1)} 0.3s ease forwards;
`

export const navigation = (position, sliderCSSVars) => {
  const top = css`
    display: none;

    ${above["m"]} {
      display: ${sliderCSSVars.displayNavigationTablet};
    }

    ${above["l"]} {
      display: ${sliderCSSVars.displayNavigationDesk};
    }
  `

  const bottom = css`
    display: ${sliderCSSVars.displayNavigation};
    padding-top: 8px;

    ${above["m"]} {
      display: none;
    }
  `

  return css`
    display: flex;
    align-items: center;
    justify-content: space-between;
    gap: 24px;

    ${above["m"]} {
      justify-content: flex-end;
    }

    ${position === "top" && top}
    ${position === "bottom" && bottom}
  `
}

export const index = css`
  font-family: ${fontsCP["font-primary"]};
  font-size: 20px;
  font-style: normal;
  font-weight: 600;
  line-height: 1.5;
  padding-right: 0;
  color: $neutral70;
  color: ${colorsCP["neutral-70"]};

  ${above["m"]} {
    padding-right: 8px;
  }
`

export const trail = (sliderCSSVars) => {
  return css `
    width: 100%;
    display: flex;
    gap: ${sliderCSSVars.gap};
    -webkit-overflow-scrolling: touch;
    scroll-snap-type: x mandatory;
    overflow-x: scroll;
    scrollbar-width: none;

    &::-webkit-scrollbar {
      display: none;
    }

    ${above["m"]} {
      gap: ${sliderCSSVars.gapTablet};
    }

    ${above["l"]} {
      gap: ${sliderCSSVars.gapDesk};
    }

    > .slide {
      flex: 0 0 ${sliderCSSVars.slideWidth};
      scroll-snap-align: ${sliderCSSVars.scrollAlign};

      ${above["m"]} {
        flex: 0 0 ${sliderCSSVars.slideWidthTablet};
        scroll-snap-align: ${sliderCSSVars.scrollAlignTablet};
      }

      ${above["l"]} {
        flex: 0 0 ${sliderCSSVars.slideWidthDesk};
        scroll-snap-align: ${sliderCSSVars.scrollAlignDesk};
      }
    }
  `
}

export const trailHolder = css`
  overflow-y: hidden;
  flex: 1;
`

export const arrowHolder = css`
  display: block;
  align-items: center;
  justify-content: center;

  ${above["m"]} {
    display: flex;
  }

  ${above["l"]} {
    display: flex;
  }
`

export const arrowBtn = (isDisabled) => {
  const disabled = css`
    background-color: ${colorsCP["neutral-30"]};
    cursor: default;

    .icon {
      stroke: ${colorsCP["neutral-50"]};
    }
  `

  return css`
    display: flex;
    align-items: center;
    justify-content: center;
    outline: none;
    border: none;
    background-color: ${colorsCP["blue-40"]};
    width: 32px;
    height: 32px;
    border-radius: 50%;
    cursor: pointer;
    transition: opacity 0.2s ease;

    .icon {
      width: 16px;
      height: 16px;
      stroke: ${colorsCP["neutral-00"]};
    }

    ${!!isDisabled && disabled}
  `
}
